import MRitualCard from './MRitualCard.vue';

export { MRitualCard };
export default MRitualCard;
